import React from 'react';
import { AcceptedProps } from './interface/accepted-props';
import SwitchType from './type/boolean/switch';

const SwitchObject: React.FC<AcceptedProps> = (props) => {
  return <SwitchType {...props} />
}

export default SwitchObject;